import { render, staticRenderFns } from "./SelectSachDialog.vue?vue&type=template&id=6196d4d7&scoped=true"
import script from "./SelectSachDialog.vue?vue&type=script&lang=js"
export * from "./SelectSachDialog.vue?vue&type=script&lang=js"
import style0 from "./SelectSachDialog.vue?vue&type=style&index=0&id=6196d4d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6196d4d7",
  null
  
)

export default component.exports